<template>
  <WdsAvatarLabel :path="avatarPath" truncated sm>
    <template #subText>
      <WdsText primary>
        {{ column?.company.name ?? '' }}
      </WdsText>
    </template>
  </WdsAvatarLabel>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsAvatarLabel, WdsText } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { getAvatarPath } from '@/utils/avatar'

const frag = graphql(`
  fragment HireCompanyColumn on Hire {
    id
    company {
      id
      name
      avatar
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof frag> }>()
const column = computed(() => useFragment(frag, props.row))

const avatarPath = computed(() =>
  getAvatarPath(column.value.company.avatar, column.value.company.id),
)
</script>
